import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";

export default function Layout() {
  const location = useLocation();

  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    let lenis;
    let raf;
    if (!reduce) {
      lenis = new Lenis({
        duration: 1.15,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        smoothWheel: true,
      });
      window.__lenis = lenis;
      const loop = (time) => {
        lenis.raf(time);
        raf = requestAnimationFrame(loop);
      };
      raf = requestAnimationFrame(loop);
    }
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const id = a.getAttribute("href");
      if (id.length < 2) return;
      const el = document.querySelector(id);
      if (el) {
        e.preventDefault();
        if (lenis) lenis.scrollTo(el, { offset: -80 });
        else el.scrollIntoView({ behavior: "smooth" });
      }
    };
    document.addEventListener("click", onClick);
    return () => {
      document.removeEventListener("click", onClick);
      if (raf) cancelAnimationFrame(raf);
      if (lenis) {
        window.__lenis = null;
        lenis.destroy();
      }
    };
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash;
      setTimeout(() => {
        const el = document.querySelector(id);
        if (el) {
          if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80 });
          else el.scrollIntoView();
        }
      }, 300);
    } else {
      if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="App noise-layer bg-base" data-testid="relumia-app">
      <Nav />
      <Outlet />
      <Footer />
      <Toaster position="top-center" richColors />
    </div>
  );
}
